var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCostB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7999 1H5.19993C3.22006 1 2.23012 1 1.61503 1.61508C0.99994 2.23015 0.99994 3.2201 0.99994 5.2V6.6C0.99994 8.57988 0.99994 9.56982 1.61503 10.1849C2.23012 10.8 3.22006 10.8 5.19993 10.8H10.7999",
    stroke: "#007BFF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8999 3.80057C13.3247 4.21346 14.9999 5.31236 14.9999 5.90057C14.9999 6.48878 13.3247 7.58771 12.8999 8.00057",
    stroke: "#007BFF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99994 3.80057C7.57518 4.21346 5.89994 5.31236 5.89994 5.90057C5.89994 6.48878 7.57518 7.58771 7.99994 8.00057",
    stroke: "#007BFF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 5.90147H6.59995",
    stroke: "#007BFF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostB);
export default __webpack_public_path__ + "static/media/cost-b.8cee95bae1cbbc096857f112198b4fb6.svg";
export { ForwardRef as ReactComponent };